import api from './api';

export interface Dokument {
  dokumentID: number;
  adresseID?: number;
  vorlageID?: number;
  dokumentTyp: string;
  betreff: string;
  dateiPfad: string;
  status: string;
  erstelltAm: string;
  versendetAm?: string;
}

export interface TranslationResult {
  success: boolean;
  translatedText?: string;
  sourceLanguage?: string;
  targetLanguage?: string;
  provider?: string;
  errorMessage?: string;
}

export interface LanguageDetectionResult {
  success: boolean;
  detectedLanguage?: string;
  languageName?: string;
  confidence?: number;
  errorMessage?: string;
}

export interface SupportedLanguages {
  languages: Record<string, string>;
  deepLAvailable: boolean;
}

export const dokumenteService = {
  // Get all documents
  async getAll(): Promise<Dokument[]> {
    try {
      const response = await api.get<Dokument[]>('/dokumente');
      return response.data;
    } catch (error) {
      console.error('Fehler beim Laden der Dokumente:', error);
      return [];
    }
  },

  // Get documents assigned to a project
  async getByProject(projectId: number): Promise<Dokument[]> {
    try {
      const response = await api.get<Dokument[]>(`/projects/${projectId}/documents`);
      return response.data;
    } catch (error) {
      console.error('Fehler beim Laden der zugeordneten Dokumente:', error);
      return [];
    }
  },

  // Translate text
  async translateText(
    text: string,
    targetLanguage: string = 'de',
    sourceLanguage: string = 'auto',
    provider: string = 'auto'
  ): Promise<TranslationResult> {
    const response = await api.post<TranslationResult>('/dokumente/translate', {
      text,
      sourceLanguage,
      targetLanguage,
      provider,
    });
    return response.data;
  },

  // Translate document by ID
  async translateDocument(
    dokumentId: number,
    targetLanguage: string = 'de',
    sourceLanguage: string = 'auto',
    provider: string = 'auto'
  ): Promise<TranslationResult> {
    const response = await api.post<TranslationResult>(`/dokumente/${dokumentId}/translate`, {
      sourceLanguage,
      targetLanguage,
      provider,
    });
    return response.data;
  },

  // Detect language
  async detectLanguage(text: string): Promise<LanguageDetectionResult> {
    const response = await api.post<LanguageDetectionResult>('/dokumente/detect-language', {
      text,
    });
    return response.data;
  },

  // Get supported languages
  async getSupportedLanguages(): Promise<SupportedLanguages> {
    const response = await api.get<SupportedLanguages>('/dokumente/translation/languages');
    return response.data;
  },
};
